export default {"src":"https://marketing-edge-assets.lemonade.com/_next/static/media/life.e28d52f9.svg","height":97,"width":118,"blurWidth":0,"blurHeight":0};